import React from 'react';

import classes from './AboutDescription.module.scss';

const description = (props) => (
  <p className={classes.Description}>{props.children}</p>
);

export default description;